/** @typedef {import('./Props').default} Props */

import './GenericVendors';
import React from 'react';
import GenericVendorsOverlay from './GenericVendorsOverlay';
import GenericVendorsTable from './GenericVendorsTable';
import Loading from '../../../../shared/Loading';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function GenericVendors(props) {
	if (props.isGettingData) {
		return <Loading />;
	}

	return (
		<section className="relative mb-20">
			<GenericVendorsTable />
			<div className="message-overlay">
				<GenericVendorsOverlay
					link={props.link}
					userRole={props.userRole}
				/>
			</div>
		</section>
	);
}

export default React.memo(GenericVendors);
